/**
 * Created by wanlei on 2019/8/15.
 */
import 'whatwg-fetch'
import { queryParams } from './urlHelper';
import { APIHOST } from '../constants/common';
import { getCookie } from './common'

const fetchAsync = async function(url, method, data, headData = {}) {
  let apiHostPath = APIHOST;

  if (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) {
    apiHostPath = '';
  }

  const myHeaders = new Headers();

  const { isAddToken, isAddCookie } = headData

  const contentType = headData.contentType || 'application/json; charset=UTF-8';

  myHeaders.append('Content-Type', contentType);

  if (isAddToken) {
    const token = getCookie('u_token');
    myHeaders.append('token', token);
  }

  const req = {
    method: method,
    headers: myHeaders
  };

  if (isAddCookie) {
    req['credentials'] = 'include';
  }

  if (method === 'GET') {
    if (!data) {
      data = {};
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + queryParams(data);
  } else {
    if (contentType === 'application/json; charset=UTF-8') {
      req.body = JSON.stringify(data);
    } else {
      let ret = '';
      for (var i in data) {
        ret += encodeURIComponent(i) + '=' + encodeURIComponent(data[i]) + '&';
      }
      req.body = ret;
    }
  }

  return fetch(apiHostPath + url, req).then(function(response) {
    if (!response.ok) {
      return response.json().then(function(errorInfo) {
        const error = new Error('serverError');
        error.source = 'server';
        error.error = errorInfo;
        throw error;
      });
    }
    return response.json();
  }).catch(function(err) {
    if (!err.source) {
      err.source = 'network';
    }
    throw err;
  });
};

export async function get(url, data, contentType, sourceType = null, isAddToken = false, isAddCookie) {
  return await fetchAsync(url, 'GET', data, contentType, sourceType, isAddToken, isAddCookie);
}

export async function post(url, data, contentType, sourceType = null, isAddToken = false, isAddCookie) {
  return await fetchAsync(url, 'POST', data, contentType, sourceType, isAddToken, isAddCookie);
}
